var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconosparainterfazdepostulaciones12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 81.2 101.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-red {\r\n        fill: #dd5b5b;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-red",
    d: "M44.11,86.61c7.59-9.49,24.88-32.5,24.88-45.42,0-15.67-12.72-28.39-28.39-28.39s-28.39,12.72-28.39,28.39c0,12.92,17.3,35.93,24.88,45.42,1.82,2.26,5.19,2.26,7.01,0h0ZM40.6,31.73c5.23,0,9.46,4.24,9.46,9.46s-4.24,9.46-9.46,9.46-9.46-4.24-9.46-9.46,4.24-9.46,9.46-9.46Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconosparainterfazdepostulaciones12);
export default __webpack_public_path__ + "static/media/Iconos para interfaz de postulaciones-12.6998f7de557dfb524d5a4f293c2c54ae.svg";
export { ForwardRef as ReactComponent };